import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { w as withTaktFallbackId } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { I as IconButton } from '../../Button/IconButton/IconButton-CAx4y7vS.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const PageNavButton = withTaktFallbackId(IconButton);
const PaginationButton = ({
  id,
  ariaLabel,
  onClick,
  icon,
  disabled = false,
  taktId,
  taktValue,
  taktFallbackId,
  ...rest
}) => /*#__PURE__*/React__default.createElement(PageNavButton, _extends({}, rest, {
  id: id,
  icon: icon,
  onClick: onClick,
  label: ariaLabel,
  disabled: disabled,
  taktId: taktId,
  taktValue: taktValue,
  taktFallbackId: taktFallbackId
}));

export { PaginationButton as P };
//# sourceMappingURL=PaginationButton-DMbVKhZU.js.map
